// Theme-driven styling for the auth/settings forms, derived from the shared radar
// palette (see ../theme) so the whole user app feels like one cockpit instrument and
// follows the same dark/light switch. Call makeAuthStyles(colors) with the active
// theme colors from useTheme().
export function makeAuthStyles(C) {
  return {
    page: {
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: C.bg, color: C.textStrong, padding: 16,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      boxSizing: 'border-box',
    },
    card: {
      width: '100%', maxWidth: 360, background: C.panel, border: `1px solid ${C.border}`,
      borderRadius: 14, padding: 24, display: 'flex', flexDirection: 'column', gap: 14,
    },
    title: { fontSize: 22, fontWeight: 800, letterSpacing: 0.5, margin: 0, textAlign: 'center', color: C.textStrong },
    label: { fontSize: 11, fontWeight: 700, letterSpacing: 0.5, color: C.textMuted, textTransform: 'uppercase' },
    field: { display: 'flex', flexDirection: 'column', gap: 5 },
    input: {
      background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, color: C.textStrong,
      padding: '11px 12px', fontSize: 15, outline: 'none', width: '100%', boxSizing: 'border-box',
    },
    button: {
      background: C.north, border: 'none', borderRadius: 8, color: '#fff', fontWeight: 800,
      letterSpacing: 0.5, padding: '12px', fontSize: 15, cursor: 'pointer', marginTop: 4,
    },
    buttonAlt: {
      background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, color: C.text,
      fontWeight: 700, padding: '11px', fontSize: 14, cursor: 'pointer',
    },
    link: { color: C.altDown, fontSize: 13, textAlign: 'center', cursor: 'pointer', background: 'none', border: 'none' },
    linkInline: { color: C.altDown, fontSize: 11, textDecoration: 'none', whiteSpace: 'nowrap' },
    error: { color: C.altUp, fontSize: 13, textAlign: 'center', minHeight: 16 },
    hint: { fontSize: 11, color: C.textMuted },
    labelRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 },
    topBar: { display: 'flex', justifyContent: 'flex-end' },
  };
}

// DRF errors arrive as { field: ["msg", ...] } or { detail: "msg" }; flatten to one line.
export function errText(err) {
  const d = err?.data;
  if (!d) return err?.message || 'Something went wrong';
  if (typeof d === 'string') return d;
  if (d.detail) return d.detail;
  const parts = [];
  for (const [k, v] of Object.entries(d)) parts.push(`${k}: ${Array.isArray(v) ? v.join(', ') : v}`);
  return parts.join(' · ') || 'Something went wrong';
}
